import styled from "styled-components";

export const TariffContainer = styled.div<{ selected: boolean }>`
  padding: 4px;
  border: 1px solid ${props => (props.selected ? "#395ca3" : "#e5e7eb")};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: ${props => (props.selected ? "#eff6ff" : "white")};

  &:hover {
    background-color: ${props => (props.selected ? "#eff6ff" : "#f9fafb")};
  }
`;

export const TariffContent = styled.div`
  display: flex;
  justify-content: start;
  gap: 8px;
  align-items: center;
`;

export const TariffName = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: #111827;
`;
